import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Centered Container"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "centered-container"
    }}>{`Centered Container`}</h1>
    <p>{`Create a centered, max-width container for reuse in multiple layouts.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<div
  sx={{
    maxWidth: 512,
    mx: 'auto',
    px: 3,
    py: 4,
  }}>
  Centered
</div>
`}</code></pre>
    <p>{`First, add a `}<inlineCode parentName="p">{`container`}</inlineCode>{` size to your theme,
then use the size in your component definition.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme
export default {
  sizes: {
    container: 768,
  },
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

// example Container component
export default (props) => (
  <div
    {...props}
    sx={{
      maxWidth: 'container',
      mx: 'auto',
      px: 3,
    }}
  />
)
`}</code></pre>
    <p>{`See also: `}<a parentName="p" {...{
        "href": "/components/container"
      }}>{`Container component`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      